import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  href,
  onClick
}: ButtonProps) {
  const classes = `
    relative overflow-hidden rounded-xl bg-accent-gradient px-8 py-4
    font-heading text-lg font-bold text-[#0f1724] shadow-[0_0_20px_rgba(34,211,238,0.3)]
    transition-shadow hover:shadow-[0_0_30px_rgba(34,211,238,0.5)] inline-block text-center no-underline
    active:scale-[0.98] transition-transform
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  if (href) {
    const handleClick = () => {
      if (onClick) {
        onClick();
      }
    };
    return <a href={href} rel="noopener noreferrer" onClick={handleClick} className={classes} data-id="element-142">
        <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-143">
          {children}
        </span>
      </a>;
  }
  return <button className={classes} onClick={onClick} data-id="element-144">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-145">
        {children}
      </span>
    </button>;
}